import { resolvePath } from '@/utils/Path';

export default [
  {
    name: 'bg',
    type: 'texture',
    path: resolvePath(require("@/assets/img/background-transition.jpg"))
  },
];